<template>
	<div class="page" :style="{ backgroundImage: `url(${imgtop}), url(${imgbottom})`}">
		<img class="title" :src="mainTitle" alt="标题" />
	
		<div class="intro-section">
			<div class="intro-title border-radius-top"> <img src="../assets/images/lianxi.png" alt="标题" /> </div>
			<div class="content">
				<div class="intro-card contact-card">
					<div class="contact-header">
						<div class="contact-th">地区</div>
						<div class="contact-th">联系人</div>
						<div class="contact-th1">联系电话</div>
					</div>
					<div 
						class="contact-row" 
						v-for="(item, idx) in contactList" 
						:key="idx"
					>
						<div class="contact-td">{{ item.area || '' }}</div>
						<div class="contact-td">
							<div class="contact-multi" v-if="item.name && item.name.includes('\n')">
								<span class="contact-text" v-for="(name, i) in item.name.split('\n')" :key="i">{{ name }}</span>
							</div>
							<span v-else>{{ item.name || '' }}</span>
						</div>
						<div class="contact-td1">
							<div class="contact-multi" v-if="item.phone && item.phone.includes('\n')">
								<span class="contact-text" v-for="(phone, i) in item.phone.split('\n')" :key="i">{{ phone }}</span>
							</div>
							<span v-else>{{ item.phone || '' }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="height-100"></div>
		<!-- <Footer></Footer> -->
	</div>
</template>

<script>
import Footer from "../components/Footer";
import { get } from "../utils/request";

export default {
	components: {
		Footer
	},
	data() {
		return {
			// 图片导入
			imgtop: require('@/assets/images/main_bg_top.jpg'),
			imgbottom: require('@/assets/images/main_bg_bottom.jpg'),
			mainTitle: require('@/assets/images/main_title.png'),
			contactList: []
		}
	},
	mounted() {
		this.fetchContactList()
	},
	methods: {
		async fetchContactList() {
			try {
				const res = await get('/tszh/api/util/contacts/list', {}, {
					baseURL: 'https://zyds.cyol.com',
					showErrToast: true
				})
				
					let list = res
					
					// 转换数据格式，确保字段名为 area, name, phone
					this.contactList = list.map(item => {
						return {
							area: item.area || item.region || item.province || item.地区 || '',
							name: item.name || item.contact || item.联系人 || item.contactName || '',
							phone: item.phone || item.tel || item.telephone || item.联系电话 || item.contactPhone || ''
						}
					})
			} catch (error) {
				console.error('获取联系人列表错误:', error)
				this.$toast && this.$toast('网络错误，请稍后重试')
			}
		}
	}
}
</script>

<style scoped>
.height-100 {
	height: 112px;
}

.page {
	min-height: 100vh;
	background-color: #092E9B;
	background-position: 
		top center,
		bottom center;
	background-size: 
		750px 831px,
		750px 695px;
	background-repeat: no-repeat;
	position: relative;
	text-align: justify;
	padding-top: 44px;
}

.title {
	width: 688px;
	height: 191px;
	margin: 40px auto 80px;
	display: block;
	max-width: 90%;
}
.content {
	background-color: #fff;
	padding: 20px;
}

.title-text {
	display: block;
	margin: 80px auto 8px;
	text-align: center;
	font-weight: 800;
	font-size: 55px;
	color: #FFFFFF;
	line-height: 94px;
}

.title-text-bottom {
	display: block;
	color: #FFFFFF;
	text-align: center;
	font-size: 25px;
	margin-bottom: 20px;
}

.intro-section {
	width: 690px;
	max-width: 90%;
	border-radius: 16px;
	margin: 30px auto 0;
}

.intro-card {
	background: #FFFFFF;
	padding: 16px 24px 28px;
	color: #2b2b2b;
	font-size: 30px;
	line-height: 1.7;
	box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.border-radius-top {
	border-radius: 16px 16px 0 0;
}

.intro-title {
	font-size: 36px;
	font-weight: 800;
	padding: 0 20px;
	color: #0A5ACF;
	height: 74px;
	background: #E6F6FF;
	line-height: 74px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.intro-title img {
	width: 332px;
	height: 35px;
}

.contact-card {
	overflow: hidden;
	border: 1px solid #CAE4FF;
	padding: 0;
}

.contact-header, .contact-row {
	display: flex;
	align-items: center;
}

.contact-header {
	background: #E6F6FF;
	font-weight: 700;
	color: #333;
}

.contact-row {
	background: #ffffff;
	color: #333;
}

.contact-row:nth-child(2n+3) {
	background: #E6F6FF;
	color: #333;
}

.contact-th, .contact-td {
	flex: 1;
	font-size: 30px;
	text-align: center;
	box-sizing: border-box;
}

.contact-th1, .contact-td1 {
	width: 280px;
	font-size: 30px;
	text-align: center;
	box-sizing: border-box;
}

.contact-multi {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.contact-text {
	display: block;
	line-height: 1.5;
}
</style>
